<!-- Gestion du dossier -->

<mat-expansion-panel [expanded]="true">

  <mat-expansion-panel-header>
    <mat-panel-title>
      <mat-icon>apps</mat-icon>
      Dipefas
    </mat-panel-title>
    <mat-panel-description>
      Gestion du dossier
    </mat-panel-description>
  </mat-expansion-panel-header>

  <mat-list>
    <mat-list-item>
      <h5 mat-line>Statut</h5>
      <p mat-line>
        <span>{{getStatusLabel()}}</span>
      </p>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>Demandeur</h5>
      <p mat-line>
        <span>{{dossier?.individu?.first_name}} {{dossier?.individu?.last_name}}</span>
      </p>
    </mat-list-item>

    <mat-list-item *ngIf="dossier.decision_commission">
      <h5 mat-line>Décision commission</h5>
      <p mat-line>
        <span>{{getDecisionCommission()}}</span>
      </p>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>Observations commission</h5>
      <p mat-line
         style="text-align: justify; font-size: 0.8em; border: 1px solid gray; padding: 2px 2px 2px 2px;"
         [innerHTML]="dossier.observations_commission | safeHtml"
         *ngIf="dossier?.observations_commission">
      </p>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>Avis</h5>
      <p mat-line *ngFor="let item of getAvis() | keyvalue">
        <strong>{{getAvisLabel(item.key)}}</strong>
        &nbsp;<span *ngFor="let avis of item.value; first as isFirst;"
              [innerHTML]="isFirst ? getAvisOuiNon(avis) : getCommentaire(avis)">
        </span>
      </p>
      <p mat-line><mat-divider></mat-divider></p>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>N° d'emploi</h5>
      <p mat-line *ngIf="dossier?.numero_emploi"><span>{{dossier.numero_emploi}}</span></p>
      <p mat-line *ngIf="! dossier?.numero_emploi"><span>/</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>Plafond d'emploi</h5>
      <p mat-line *ngIf="dossier?.plafond_emploi"><span>{{getPlafondEmploi(dossier)}}</span></p>
      <p mat-line *ngIf="! dossier?.plafond_emploi"><span>/</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>Coût estimé</h5>
      <p mat-line *ngIf="dossier?.cout_estime"><span>{{dossier.cout_estime | currency:'EUR':'symbol':'1.0-0'}}</span></p>
      <p mat-line *ngIf="! dossier?.cout_estime"><span>/</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>INM MS</h5>
      <p mat-line *ngIf="dossier?.inm"><span>{{dossier.inm}}</span></p>
      <p mat-line *ngIf="! dossier?.inm"><span>/</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>INM recrutement</h5>
      <p mat-line *ngIf="dossier?.inm_recrutement"><span>{{dossier.inm_recrutement}}</span></p>
      <p mat-line *ngIf="! dossier?.inm_recrutement"><span>/</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>Code WINPAYE</h5>
      <p mat-line *ngIf="dossier?.winpaye_sbtcp_obj?.label"><span>{{dossier?.winpaye_sbtcp_obj?.label}}</span></p>
      <p mat-line *ngIf="! dossier?.winpaye_sbtcp_obj?.label"><span>/</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item>
      <h5 mat-line>Coût retenu commission</h5>
      <p mat-line *ngIf="dossier?.cout_valide"><span>{{dossier.cout_valide | currency:'EUR':'symbol':'1.0-0'}}</span></p>
      <p mat-line *ngIf="! dossier?.cout_valide"><span>/</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <!-- période demandée -->

    <mat-list>
      <mat-list-item>
        <h5 mat-line>Période demandée</h5>
        <p mat-line>
          <span>Du {{dossier.date_debut | date: 'dd/MM/yyyy'}}</span> <span> au {{dossier.date_fin | date: 'dd/MM/yyyy'}}</span>
          <span> (durée: {{dossierService.getDaysBetweenDates(dossierService.getDateFromString(dossier.date_debut),
            dossierService.getDateFromString(dossier.date_fin))}} jours)</span>
        </p>
      </mat-list-item>

      <!-- selon type rémunération -->

      <mat-list-item *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.indiciaire">
        <h5 mat-line>Quotité</h5>
        <p mat-line>
          <span>{{(dossier.quotite?dossier.quotite:'non renseigné')}}</span>
        </p>
        <mat-divider></mat-divider>
      </mat-list-item>

      <mat-list-item *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.horaire">
        <h5 mat-line>Vacation horaire</h5>
        <p mat-line>
          <span>{{(dossier.vacation_horaires?dossier.vacation_horaires:'non renseigné')}}</span>
        </p>
        <mat-divider></mat-divider>
      </mat-list-item>
    </mat-list>

    <!-- période retenue commission -->

    <mat-list *ngIf="canSeeCommission()">
      <mat-list-item>
        <h5 mat-line>Période retenue commission</h5>
        <p mat-line>
          <span>Du {{dossier.date_debut_validee | date: 'dd/MM/yyyy'}}</span> <span> au {{dossier.date_fin_validee | date: 'dd/MM/yyyy'}}</span>
          <span> (durée: {{dossierService.getDaysBetweenDates(dossierService.getDateFromString(dossier.date_debut_validee),
            dossierService.getDateFromString(dossier.date_fin_validee))}} jours)</span>
        </p>
      </mat-list-item>

      <!-- selon type rémunération -->

      <mat-list-item *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.indiciaire">
        <h5 mat-line>Quotité</h5>
        <p mat-line>
          <span>{{(dossier.quotite_validee?dossier.quotite_validee:'non renseigné')}}</span>
        </p>
        <mat-divider></mat-divider>
      </mat-list-item>

      <mat-list-item *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.horaire">
        <h5 mat-line>Vacation horaire</h5>
        <p mat-line>
          <span>{{(dossier.vacation_horaires_validee?dossier.vacation_horaires_validee:'non renseigné')}}</span>
        </p>
        <mat-divider></mat-divider>
      </mat-list-item>
    </mat-list>

    <mat-list *ngIf="! canSeeCommission()">
      <mat-list-item>
        <h5 mat-line>Période retenue commission</h5>
        <p mat-line>/</p>
      </mat-list-item>
    </mat-list>

    <mat-list-item *ngIf="dossier?.recrutement_type">
      <h5 mat-line>Type de recrutement</h5>
      <p mat-line><span>{{getRecrutementType()}}</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item *ngIf="dossier?.recrute_obj">
      <h5 mat-line>Recruté</h5>
      <p mat-line><span>{{dossier.recrute_obj.first_name}} {{dossier.recrute_obj.last_name}}</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item *ngIf="dossier?.date_prise_fonction">
      <h5 mat-line>Date de prise de fonction</h5>
      <p mat-line><span>{{dossier.date_prise_fonction | date: 'dd/MM/yyyy'}}</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>

    <mat-list-item *ngIf="dossier?.gestionnaire_obj">
      <h5 mat-line>Gestionnaire SPTA</h5>
      <p mat-line><span>{{dossier.gestionnaire_obj.first_name}} {{dossier.gestionnaire_obj.last_name}}</span></p>
      <mat-divider></mat-divider>
    </mat-list-item>
  </mat-list>

</mat-expansion-panel>
